<div class="page-body">
    <h1 data-aos="fade-down" data-aos-duration="800">Digital Portraits</h1>
    <div class="info">
        <p><strong>Context</strong><br>Vector portraits of friends</p>
        <p><strong>Tools</strong><br>Adobe Illustrator</p>
    </div>

    <p>I enjoy creating portraits that convey the personal brand and personality of the person being drawn.</p>
    <img class="process" src="assets/fun/dan.png">
    <img class="process" src="assets/fun/shrey.png">
    <img class="process" src="assets/fun/meara.png">
    <img class="process" src="assets/fun/portrait.png">
    
    <a class="next" routerLink="/sketch">Next Work -></a>
</div>
